import React from 'react';
import { CONTACT_EMAIL } from '../config/contact';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h1 className="hero-title">
          Research. Technology. Trading.
        </h1>
        <p className="hero-subtitle">
          {/* Applying quantitative methods to understand market signals and behavioral dynamics. */}
          {/* Leveraging statistical modeling and machine learning to originate betting lines, identify inefficiencies, and quantify market edges. */}
          Applying machine learning to originate betting lines, identify inefficiencies, and quantify edges.
        </p>
        <a href={`mailto:${CONTACT_EMAIL}`} className="btn-hero-contact">
          Contact TQS →
        </a>
      </div>
    </section>
  );
};

export default Hero;
